import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
const AuthContext = createContext();

const API_HOST = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [token, setToken] = useLocalStorage("auth", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (token) => {
    const user = jwtDecode(token);
    setToken(token);
    setUser(user);
    navigate("/admin/dashboard");
  };

  // call this function to sign out logged in user
  const logout = () => {
    localStorage.removeItem("auth");
    localStorage.removeItem("user");
    window.location.reload();
    navigate("/auth/signin");
    // e.stopPropagation();
    // e.preventDefault();
    // axios
    //   .delete("/api/v1/refresh-token", {
    //     baseURL: API_HOST,
    //     withCredentials: true,
    //   })
    //   .then(() => {
    //     setUser(null);
    //     setToken(null);
    //     navigate("/", { replace: true });
    //   })
    //   .catch((e) => {
    //     throw e;
    //   });
  };

  return (
    <AuthContext.Provider value={{ user, token, login, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
